// extracted by mini-css-extract-plugin
export default {"root":"OnboardingHeading_root__7ig-D","headerWithButton":"OnboardingHeading_headerWithButton__j5ft9"};